import React from 'react';
import PropTypes from 'prop-types';
import Grid from '../components/Grid.jsx';
import FormikKeyboardDatePicker from '../formik-fields/FormikKeyboardDatePicker.jsx';

const GridFormikKeyboardDatePicker = ({ gridProps, ...props }) => {
  return (
    <Grid item {...gridProps}>
      <FormikKeyboardDatePicker { ...props } />
    </Grid>
  );
};

GridFormikKeyboardDatePicker.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  format: PropTypes.string,
  valueFormat: PropTypes.string,
  gridProps: PropTypes.object,
  fieldProps: PropTypes.object,
};

export default GridFormikKeyboardDatePicker;
